/**
 * "Is that you?" on an emailed invite (founder 6443495747): the join screen's answer, kept for the
 * mid-meeting re-auths so someone the invite was forwarded to is never re-admitted as the invitee.
 * Its own module, beside the notice keys, so a test that mocks the API client keeps working.
 */
export const GUEST_IS_INVITEE_KEY = "ftl_guest_is_invitee";

export function storedIsInvitee(): boolean | null {
  try {
    const v = sessionStorage.getItem(GUEST_IS_INVITEE_KEY);
    return v === "true" ? true : v === "false" ? false : null;
  } catch {
    return null;
  }
}

function nameTokens(text: string): string[] {
  return text.toLowerCase().split(/[^a-z]+/).filter((t) => t.length >= 2);
}

/**
 * Whether a typed name could be the invitee (founder 6466505458: Colleen answered yes on Ross's
 * forwarded invite and joined as Ross). Mirrors typed_name_could_be_invitee in
 * app/services/livekit_token_service.py, which decides: a yes counts only when the typed name shares
 * a word with the invite's name (or its start, "Rob" for "Robert"), or a word in the address.
 * `invitedAs` is the invite's name, or its address when it has no name.
 */
export function nameCouldBeInvitee(typed: string, invitedAs: string | null | undefined): boolean {
  const target = invitedAs ?? "";
  const isEmail = target.includes("@");
  const local = isEmail ? target.split("@")[0].toLowerCase().replace(/[^a-z]/g, "") : "";
  const theirs = isEmail ? [] : nameTokens(target);
  if (theirs.length === 0 && !local) return true;
  return nameTokens(typed).some(
    (t) =>
      theirs.includes(t) ||
      (t.length >= 3 &&
        (local.includes(t) || theirs.some((w) => w.startsWith(t) || (w.length >= 3 && t.startsWith(w))))),
  );
}
